import { footerLinks } from "@/content/homepage";

export default function HomeFooter() {
  return (
    <footer className="av-footer" data-testid="footer">
      <div className="av-shell">
        <div className="av-footer-top">
          <a
            className="av-footer-wordmark-link"
            href="/"
            aria-label="Averentia — Home"
          >
            <img
              className="av-footer-wordmark"
              src="/brand/averentia-wordmark-inverse.png"
              alt=""
            />
          </a>
          <nav className="av-footer-links" aria-label="Footer navigation">
            {footerLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target={link.external ? "_blank" : undefined}
                rel={link.external ? "noreferrer" : undefined}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
        <div className="av-footer-bottom">
          <p>Neocarb Technology Private Limited</p>
          <div className="av-footer-legal">
            <p>© 2026 Averentia. All rights reserved.</p>
            <a href="/privacy" data-testid="footer-privacy-link">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
